import * as actionTypes from '../actions/allActionList';
import { updateStateWithoutNesting } from '../../utils/store/updateStateWithoutNesting';
import { updateUserObjectWithNesting } from '../../utils/store/updateUserObjectWithNesting';

const initialState = {
  authListenStarted: false,
  authListenDone: false,
  authError: null,
  signUpStarted: false,
  signUpError: null, //server-side errors (validation)
  justSignedUp: false, // for tutorial purposes
  signInStarted: false,
  signInError: null, //server-side errors (validation)
  logoutStarted: false,
  isNotEmailVerified: false,
  userData: null,
  userAvatar: false,

  /** For Profile Editing **/
  startedEditingProfile: false,
  doneEditingProfile: false,
  errorEditingProfile: false,
  editError: null,
  avatarUploadProgress: 0,
  startedUploadingAvatar: false,
  finishedUploadingAvatar: false,
  avatarUploadError: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CLIENT_SET_SIGN_IN_ERROR:
      return updateStateWithoutNesting(state, { signInError: action.message });
    case actionTypes.CLIENT_SET_SIGN_UP_ERROR:
      return updateStateWithoutNesting(state, { signUpError: action.message });
    case actionTypes.RESET_AUTH_ERRORS:
      return updateStateWithoutNesting(state, { signUpError: null, signInError: null });
    case actionTypes.START_AUTH_LISTEN:
      return updateStateWithoutNesting(state, { authListenStarted: true });
    case actionTypes.AUTHENTICATED:
      return updateUserObjectWithNesting(state, {
        authListenStarted: false,
        authListenDone: true,
        userData: action.verifiedData,
        userAvatar: action.isUploaded,
      });
    case actionTypes.UNAUTHENTICATED:
      return updateStateWithoutNesting(state, {
        authListenStarted: false,
        authListenDone: true,
        authError: action.message,
      });
    case actionTypes.UNVERIFIED_EMAIL:
      return updateStateWithoutNesting(state, { isNotEmailVerified: true });
    case actionTypes.START_SIGN_UP_CALL:
      return updateStateWithoutNesting(state, { signUpStarted: true, signUpError: null });
    case actionTypes.SUCCESS_SIGNING_UP:
      return updateUserObjectWithNesting(state, {
        signUpStarted: false,
        signUpError: null,
        justSignedUp: true,
        userData: action.verifiedData,
      });
    case actionTypes.FAILED_SIGNING_UP:
      return updateStateWithoutNesting(state, {
        signUpStarted: false,
        signUpError: action.errorMessage,
      });
    case actionTypes.START_SIGN_IN_CALL:
      return updateStateWithoutNesting(state, { signInStarted: true, signInError: null });
    case actionTypes.SUCCESS_SIGNING_IN:
      return {
        ...state,
        userData: action.verifiedData,
        userAvatar: action.isUploaded,
        signInStarted: false,
      };
    case actionTypes.FAILED_SIGNING_IN:
      return updateStateWithoutNesting(state, {
        signInStarted: false,
        signInError: action.errorMessage,
      });
    case actionTypes.START_LOGOUT:
      return updateStateWithoutNesting(state, { logoutStarted: true });
    case actionTypes.SUCCESS_LOGOUT:
      return updateUserObjectWithNesting(state, {
        userData: action.verifiedData,
        logoutStarted: false,
      });
    case actionTypes.FAILED_LOGOUT:
      return updateStateWithoutNesting(state, { logoutStarted: false });
    case actionTypes.STARTED_EDITING_PROFILE:
      return updateStateWithoutNesting(state, {
        startedEditingProfile: true,
        doneEditingProfile: false,
        errorEditingProfile: false,
        editError: null,
      });
    case actionTypes.EDITED_PROFILE:
      return updateUserObjectWithNesting(state, {
        startedEditingProfile: false,
        doneEditingProfile: true,
        userData: {
          ...action.userData,
          profile: {
            ...action.userData.profile,
            avatar: action.isUploaded,
          },
        },
      });
    case actionTypes.FAILED_EDITING_PROFILE:
      return updateStateWithoutNesting(state, {
        startedEditingProfile: false,
        doneEditingProfile: true,
        errorEditingProfile: true,
      });
    case actionTypes.RESET_EDITING_PROFILE_STATE:
      return updateStateWithoutNesting(state, {
        startedEditingProfile: false,
        doneEditingProfile: false,
        errorEditingProfile: false,
        editError: null,
      });
    case actionTypes.EDIT_PROFILE_SUCCESS:
      return updateUserObjectWithNesting(state, {
        userData: action.userData,
        userAvatar: action.isUploaded,
        editError: null,
        startedEditingProfile: false,
        doneEditingProfile: true,
      });
    case actionTypes.EDIT_PROFILE_FAILED:
      return updateStateWithoutNesting(state, {
        editError: action.message,
        startedEditingProfile: false,
      });
    case actionTypes.STARTED_UPLOADING_AVATAR:
      return updateStateWithoutNesting(state, {
        startedUploadingAvatar: true,
        avatarUploadError: null,
      });
    case actionTypes.FAILED_UPLOADING_AVATAR:
      return updateStateWithoutNesting(state, {
        startedUploadingAvatar: false,
        avatarUploadError: action.message,
      });
    case actionTypes.FINISHED_UPLOADING_AVATAR:
      return updateStateWithoutNesting(state, {
        startedUploadingAvatar: false,
        finishedUploadingAvatar: true,
      });
    case actionTypes.RESET_UPLOADING_AVATAR_STATE:
      return updateStateWithoutNesting(state, {
        avatarUploadProgress: 0,
        startedUploadingAvatar: false,
        finishedUploadingAvatar: false,
      });
    case actionTypes.UPDATE_AVATAR_UPLOAD_PROGRESS:
      return updateStateWithoutNesting(state, {
        avatarUploadProgress: action.value,
      });
    default:
      return state;
  }
};

export default reducer;
